module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Fotos")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.fotos.length > 0) ? [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.fotos), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id
    }, [_c('v-list-tile-content', {
      staticClass: "pl-5"
    }, [_c('v-list-tile-sub-title', [_vm._v(_vm._s(item.data) + " às " + _vm._s(item.horario))]), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }]
    }, [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.legenda))])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "pr-5"
    }, [_c('v-menu', [_c('v-icon', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }]
    }, [_c('v-list-tile-title', [_vm._v("Visualizar")])], 1), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "640"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Editar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.itemEditar.titulo))])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
      attrs: {
        "label": "Legenda"
      },
      model: {
        value: (_vm.formEditar.fields.legenda),
        callback: function($$v) {
          _vm.formEditar.fields.legenda = $$v
        },
        expression: "formEditar.fields.legenda"
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Apagar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.fotos.length) ? _c('v-divider', {
      key: item.id
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma foto cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "720"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('fotos', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('file-input', {
    key: _vm.inputKey,
    attrs: {
      "accept": "image/*",
      "icon": "add_a_photo",
      "label": "Selecionar foto"
    },
    on: {
      "formData": _vm.onFilePicked
    },
    model: {
      value: (_vm.form.fields.fotoFilename),
      callback: function($$v) {
        _vm.form.fields.fotoFilename = $$v
      },
      expression: "form.fields.fotoFilename"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Legenda"
    },
    model: {
      value: (_vm.form.fields.legenda),
      callback: function($$v) {
        _vm.form.fields.legenda = $$v
      },
      expression: "form.fields.legenda"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c3cc488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesFotos.vue
// module id = 1031
// module chunks = 1